import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import { connect } from "react-redux";

import AccountDetailsPolicy from "./../../components/AccountDetailPolicy";

import spinner from "../../assets/images/aws/loadingGif.gif";

import { clearAllAwsAccMessages } from "../../store/actions";
import {
  CloudProviderContext,
  shouldShowAzurePlaceholderView,
  getAccountCloudType,
} from "../../CloudProviderContext";

const AccountsConfig = (props) => {
  const [formikInitValues, setFormikInitValues] = useState();
  const licensing = useSelector((state) => state.licensing);
  const acctList = useSelector((state) => state.acctList);
  const profile = useSelector((state) => state.profile);
  const { selectedProvider, setSelectedProvider } = useContext(CloudProviderContext);
  const isAzureView = useMemo(
    () => shouldShowAzurePlaceholderView(selectedProvider),
    [selectedProvider]
  );

  const handleAccountCloudTypeAdded = useCallback(
    (cloudType) => {
      if (!cloudType) return;
      const normalized = String(cloudType).toUpperCase();
      if (
        (normalized === "AWS" || normalized === "AZURE") &&
        normalized !== selectedProvider
      ) {
        setSelectedProvider(normalized);
      }
    },
    [selectedProvider, setSelectedProvider]
  );

  const providerAccounts = useMemo(() => {
    if (!acctList?.accounts) return [];
    return acctList.accounts.filter((account) => {
      if (account.accountNumber.includes("INIT00000001")) return false;
      return getAccountCloudType(account) === selectedProvider;
    });
  }, [acctList?.accounts, selectedProvider]);

  const getRoleAccess = useCallback(() => {
    if (
      licensing &&
      licensing.data.isLicensingComplete &&
      profile &&
      profile.userRoles &&
      profile.userRoles.includes("Administrator")
    ) {
      return 0;
    }

    return -1;
  }, [licensing, profile]);

  useEffect(() => {
    if (
      licensing &&
      licensing.data &&
      acctList &&
      acctList.accounts &&
      profile &&
      profile.userRoles
    ) {
      setFormikInitValues({
        licensing: licensing.data,
        accounts: providerAccounts,
        profile: profile,
        roleAccess: getRoleAccess(),
      });
    }
  }, [licensing, acctList, profile, providerAccounts, selectedProvider, getRoleAccess]);

  const postAwsAccMessage = props.postAwsAccMessage;
  const postAwsAccError = props.postAwsAccError;
  const clearAllAwsAccMessages = useCallback(() => {
    props.clearAllAwsAccMessages();
  }, [props]);
  useEffect(() => {
    console.log("useEffect for postAwsAccMessage:", postAwsAccMessage);
    if (postAwsAccMessage) {
      setTimeout(() => clearAllAwsAccMessages(), 5000);
    }
    if (postAwsAccError) {
      setTimeout(() => clearAllAwsAccMessages(), 5000);
    }
  }, [postAwsAccMessage, postAwsAccError, clearAllAwsAccMessages]);

  return (
    <React.Fragment>
      <React.Fragment>
        {(licensing.loading || acctList.loading || profile.loading) && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
            }}
          >
            <img src={spinner} width="32px" alt="Spinner" />
          </div>
        )}
        {(licensing.error || acctList.error || profile.error) && (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                direction: "row",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                justifyItems: "center",
                height: "80vh",
                color: "red",
              }}
            >
              <div>Something went wrong! Refresh the page.</div>
            </div>
          </React.Fragment>
        )}
        {formikInitValues && (
          <Formik initialValues={formikInitValues} enableReinitialize>
            {({ values }) => (
              <form>
                <AccountDetailsPolicy
                  key={selectedProvider}
                  isAzureView={isAzureView}
                  profile={values.profile}
                  licensing={values.licensing}
                  accounts={values.accounts}
                  roleAccess={values.roleAccess}
                  onAccountCloudTypeAdded={handleAccountCloudTypeAdded}
                />
              </form>
            )}
          </Formik>
        )}
      </React.Fragment>
      <Snackbar open={postAwsAccMessage} autoHideDuration={10000}>
        <Alert severity="success">{postAwsAccMessage}</Alert>
      </Snackbar>

      <Snackbar open={postAwsAccError} autoHideDuration={10000}>
        <Alert severity="error">{postAwsAccError}</Alert>
      </Snackbar>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { awsAccountPosting, postAwsAccMessage, postAwsAccError } =
    state.awsAcc;

  return {
    awsAccountPosting,
    postAwsAccMessage,
    postAwsAccError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAllAwsAccMessages: () => {
      dispatch(clearAllAwsAccMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountsConfig);
